import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Bowl.svg",
  "use": "Bowl.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Bowl.svg\"><path d=\"M45,46.5h0A2.5,2.5,0,0,1,42.5,49h-21A2.5,2.5,0,0,1,19,46.5h0a4.6863,4.6863,0,0,0-1.7026-3.5832A25.9324,25.9324,0,0,1,8,23V21.5A2.5,2.5,0,0,1,10.5,19h43A2.5,2.5,0,0,1,56,21.5V23a25.9324,25.9324,0,0,1-9.2974,19.9167A4.6863,4.6863,0,0,0,45,46.5Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol